import type { ComponentConfig } from '@cbhq/cds-web/core/componentConfig';

/**
 * CDS component config that keeps the input label style identity surfaces use today.
 *
 * cds-web 9.20 changed the default input label style from `label1` / `fg` (bold) to
 * `label2` / `fgMuted`. Pass this to `ComponentConfigProvider` at an app root to keep
 * the bold labels until the retail design refresh ships.
 *
 * Keep this override for control and standalone consumers; retail roots use the
 * spectrum-aware retail component config instead.
 */
export const legacyInputLabelConfig: ComponentConfig = {
  TextInput: { labelFont: 'label1', labelColor: 'fg' },
  Select: { labelFont: 'label1', labelColor: 'fg' },
  Combobox: { labelFont: 'label1', labelColor: 'fg' },
};
